<template>
  <opened
    ref="LeaseSetup"
    :leaseInfoParams="leaseInfoParams"
    :maitenaceParams="maitenaceParams"
    :tableDataFrom="tableDataFrom"
    :defaultTable="defaultTable"
    :ladderSchemeConfig="ladderSchemeConfig"
    :createOrderInfo="createOrderInfo"
    :leaseOrderDetailData="leaseOrderDetailData"
    @updateCarInfo="updateCarInfo"
    @cancel="cancel"
    @confirm="confirm"
    @previousStep="previousStep"
  />
</template>
<script>
import opened from './LeaseSetupNew.vue'

export default {
  name: 'personalAddOrderIndex',
  props: {
    createOrderInfo: {
      type: Object,
      default: () => ({}),
    },
    ladderSchemeConfig: {
      type: Object,
      default: () => ({}),
    },
    leaseInfoParams: {
      type: Object,
      default: () => ({}),
    },
    tableDataFrom: {
      type: Object,
      default: () => ({}),
    },
    defaultTable: {
      type: Array,
      default: () => [],
    },
    maitenaceParams: {
      type: Object,
      default: () => ({}),
    },
    leaseOrderDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    opened,
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    planChange(id) {
      this.$refs.LeaseSetup.planChange(id)
    },
    updateCarInfo(val) {
      this.$emit('updateCarInfo', val)
    },
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    },
    previousStep() {
      this.$emit('previousStep')
    },
  },
}
</script>
